
const getScore = (leader_id, dance_set_, users) => {
    if(users){
        return users.find(u => u._id === leader_id)
            ?.['events']
            ?.[dance_set_?.event]
            ?.['danceSelections']
            ?.[dance_set_?.dance]
            ?.[dance_set_?.category]
            ?.['cards']
            ?.[dance_set_?.round]
            ?.[dance_set_?.class]
    }

}

const getScores = (dance_set_, users, role) => {
    if(users){
        const cards = users.filter(u => {
            const user = u
                ?.['events']
                ?.[dance_set_?.event]
                ?.['danceSelections']
                ?.[dance_set_?.dance]
                ?.[dance_set_?.category]
                ?.['cards']
                ?.[dance_set_?.round]
                ?.[dance_set_?.class]
            // регулярка для UUID v1–v5
            const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

            // ищем первый
            if(user){
                const firstUUID =  Object?.keys(user)?.find(item => uuidRegex?.test(item))
                if(user && (u._id === user?.[firstUUID]?.[role ? role : "leader"]?.id)){
                    return user
                }
            }


    })
            const res = cards.map(u=> {
            const placesObj = u?.['events']
                ?.[dance_set_?.event]
                ?.['danceSelections']
                ?.[dance_set_?.dance]
                ?.[dance_set_?.category]
                ?.['cards']
                ?.[dance_set_?.round]
                ?.[dance_set_?.class]
            const places = Object.keys(placesObj).filter(p=>{
                    if(placesObj[p]?.skating_place){
                        return placesObj[p]?.skating_place
                    }

            }).map(p=>{
                return placesObj[p]?.skating_place
            })
            return {
                name:u._id,
                places:places
            }
        })
        return res;

    }

}

const median = (arr) => {
    if (!Array.isArray(arr) || arr.length === 0) {
        throw new Error("Массив должен содержать хотя бы один элемент");
    }

    const sorted = arr.slice().sort((a, b) => a - b); // Копируем и сортируем массив
    const mid = Math.floor(sorted.length / 2);

    return sorted.length % 2 !== 0
        ? sorted[mid]                 // Если нечетное количество элементов
        : (sorted[mid - 1] + sorted[mid]) / 2; // Если четное - среднее двух центральных
}
const sum = arr => arr?.reduce((acc, num) => acc + num, 0);
const roundTo3 = num => fixNaN(Math.round(num * 100) / 100); //округление до сотых
const fixNaN = (value) => {
    return Number.isNaN(value) ? 0 : value;
}
const getBalls = (leader_id, dance_set_, users) => {
    const scores = getScore(leader_id, dance_set_, users)
    //console.log("scores",scores)
    const b = []
    const jd = Object.keys(scores ?? {}).filter(item => item !== 'final')
    //console.log("jd",jd)
    jd?.map((key, index) => {
        b[index] ??= []
        b[index][0] = (scores?.[key]?.basic_leader * 7.5) / 5
        b[index][1] = (scores?.[key]?.basic_follow * 7.5) / 5
        b[index][2] = ((scores?.[key]?.lfbdh +
            scores?.[key]?.dance_perf +
            scores?.[key]?.bonus1 * 1) * 15) / 10
        b[index][3] = (scores?.[key]?.execution +
            scores?.[key]?.diff_var +
            scores?.[key]?.bonus2 * 1)
        b[index][4] = ((scores?.[key]?.interpret +
            scores?.[key]?.spontan +
            scores?.[key]?.bonus3 * 1) * 25) / 10
    })

    // Транспонируем массив (группируем по столбцам)
    const transposed = b[0]?.map((_, i) => b?.map(row => row[i]));
    // Считаем медиану для каждого столбца
    const medians = transposed?.map(median);
    //console.log("medians",medians);

    // Вычисляем коэффициенты (вычитаем медиану из каждого элемента)
    const difference = b?.map(row => row?.map((value, i) => value - medians[i]));
    //console.log("difference",difference);
    const coefficients = difference?.map(row => row?.map(c => 1 / (1 + c * c)));
    //console.log("coefficients",coefficients);
    const scaled_marks = b?.map((row, i) => row.map((value, j) => value * coefficients[i][j]));
    //console.log("scaled_marks",scaled_marks);

    const coefficients_sum = coefficients[0]?.map((_, index) => {
        return coefficients?.reduce((sum, currentArray) => sum + currentArray[index], 0);
    });

    const scaled_marks_sum = scaled_marks[0]?.map((_, index) => {
        return scaled_marks?.reduce((sum, currentArray) => sum + currentArray[index], 0);
    });

    const tmp = scaled_marks_sum?.map((value, index) => value / (coefficients_sum[index] || 0));
    //console.log("tmp",tmp);

    const result_sum = sum(tmp)
    //console.log(result_sum)

    //return b
    return roundTo3(result_sum)
}
const getBallsJJ = (leader_id, dance_set_, users) => {
    const scores = getScore(leader_id, dance_set_, users)
    //console.log("scores",scores)
    const jd = Object.keys(scores ?? {}).filter(item => item !== 'final')
    //console.log("jd",jd)
    let ball=0
    jd?.map((key, index) => {
        ball+=fixNaN((scores?.[key]?.jj*1))
    })
    //console.log(ball)
    return ball
}


/**
* Смотрим по порядку k = 1, 2, 3…
* Для каждого участника считаем: «сколько судей поставили его на место ≤ k».
* Если кто-то получает большинство ( > половины судей ), то он занимает итоговое место.
* Если несколько участников получили большинство при одном и том же k, выигрывает тот, у кого больше таких голосов.
* Если и тут равенство — тогда тай-брейк: сумма мест.
**/
function getSkatingPlaces(leader_id, dance_set_, users, role) {
    const participants = getScores(dance_set_, users, role)
    //console.log(participants)
    let results = [];
    // копия участников, чтобы исключать победителей по ходу
    let remaining = participants.map(p => ({ ...p }));
    let place = 1;
    if(remaining[0]?.places[0]) {
        while (remaining.length > 0) {
            const numJudges = remaining[0].places.length;
            const majority = Math.floor(numJudges / 2) + 1;

            let winner = null;

            // идем по k = 1, 2, 3...
            for (let k = 1; k <= remaining.length && !winner; k++) {
                // сколько судей поставили участника на место ≤ k
                let counts = remaining.map(p => {
                    let votes = p.places.filter(r => r <= k).length;
                    return {
                        ...p,
                        votes,
                        sum: p.places.reduce((a, b) => a + b, 0)
                    };
                });

                // отбираем только тех, у кого есть majority
                let eligible = counts.filter(c => c.votes >= majority);

                if (eligible.length > 0) {
                    // если несколько — сравним по количеству голосов, потом по сумме
                    eligible.sort((a, b) => {
                        if (a.votes !== b.votes) return b.votes - a.votes;
                        if (a.sum !== b.sum) return a.sum - b.sum;
                        return 0;
                    });
                    winner = eligible[0];
                }
            }

            // если вообще никто не набрал majority (бывает при малом числе судей)
            if (!winner) {
                winner = remaining
                    .map(p => ({
                        ...p,
                        sum: p.places.reduce((a, b) => a + b, 0)
                    }))
                    .sort((a, b) => a.sum - b.sum)[0];
            }

            results.push({ name: winner.name, finalPlace: place });

            // убираем победителя
            remaining = remaining.filter(p => p.name !== winner.name);

            place++;
        }
        return results.find(r => r.name === leader_id)?.finalPlace;
    }
    else return 0
}





export {getBalls,getBallsJJ, getScore, fixNaN, roundTo3, median, sum, getSkatingPlaces}